import React, { useEffect } from 'react';

import { useChangeLanguage } from '@lyearn/i18n';
import OnBoardingFlow from '@/components/OnBoardingFlow';
import PageLayout from '@/components/PageLayout';
import { useAppConfig } from '@/hooks/useAppConfig';
import useNavigation from '@/hooks/useNavigation';
import useNotification from '@/hooks/useNotification';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import useJobByCreator from '@/modules/corporate/modules/admin/hooks/useJobByCreator';
import authRoutes from '@/pages/auth/routes';

const AppRoutes: React.FC<React.PropsWithChildren> = ({ children }) => {
  const user = useUserContext();
  const navigation = useNavigation();
  const {
    site: { isUserOnboardingAiEnabled },
  } = useAppConfig();
  useJobByCreator();
  useNotification();
  useChangeLanguage(user.meta?.locale);
  const isVerifyEmail =
    window.location.pathname == authRoutes.VerifyEmail() ||
    window.location.pathname == authRoutes.VerifyEmailV2();
  // For AI-onboarding workspaces, logged-out users should land on the AI signup flow rather
  // than the classic login form.
  const loggedOutRoute = isUserOnboardingAiEnabled ? authRoutes.SignupV2() : authRoutes.Login();
  useEffect(() => {
    if (!user.id && !isVerifyEmail) {
      navigation.push(loggedOutRoute, { setFrom: true, appendQuery: false });
    }
  }, [navigation, user.id, isVerifyEmail, loggedOutRoute]);

  if (!user.id && !isVerifyEmail) {
    return null;
  }

  return (
    <OnBoardingFlow>
      <PageLayout>{children}</PageLayout>
    </OnBoardingFlow>
  );
};

export default AppRoutes;
